import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
const axiosInstance = axios.create({ baseURL: API, withCredentials: true });

const qs = (filters = {}) => {
  const p = new URLSearchParams();
  Object.entries(filters).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") p.append(k, v);
  });
  const s = p.toString();
  return s ? `?${s}` : "";
};

// ---- Exam ----
export const createExam = async (data) => {
  const res = await axiosInstance.post("/exams/create", data);
  return res.data;
};

export const getAllExams = async (filters = {}) => {
  const res = await axiosInstance.get(`/exams/all${qs(filters)}`);
  return res.data;
};

export const getExamById = async (id) => {
  const res = await axiosInstance.get(`/exams/${id}`);
  return res.data;
};

export const updateExam = async (id, data) => {
  const res = await axiosInstance.put(`/exams/update/${id}`, data);
  return res.data;
};

export const updateExamStatus = async (id, status) => {
  const res = await axiosInstance.put(`/exams/status/${id}`, { status });
  return res.data;
};

export const deleteExam = async (id) => {
  const res = await axiosInstance.delete(`/exams/delete/${id}`);
  return res.data;
};

// ---- Schedule ----
export const createExamSchedule = async (data) => {
  const res = await axiosInstance.post("/exams/schedule/create", data);
  return res.data;
};

export const getAllExamSchedules = async (filters = {}) => {
  const res = await axiosInstance.get(`/exams/schedule/all${qs(filters)}`);
  return res.data;
};

export const updateExamSchedule = async (id, data) => {
  const res = await axiosInstance.put(`/exams/schedule/update/${id}`, data);
  return res.data;
};

/** Date changes MUST go through postpone — do not send examDate on update */
export const postponeExamSchedule = async (id, data) => {
  const res = await axiosInstance.put(`/exams/schedule/postpone/${id}`, data);
  return res.data;
};

export const updateExamScheduleStatus = async (id, status) => {
  const res = await axiosInstance.put(`/exams/schedule/status/${id}`, {
    status,
  });
  return res.data;
};

export const deleteExamSchedule = async (id) => {
  const res = await axiosInstance.delete(`/exams/schedule/delete/${id}`);
  return res.data;
};

// ---- Syllabus select helper (class + subject → templates) ----
export const getSyllabusTemplatesForSchedule = async (filters = {}) => {
  const res = await axiosInstance.get(`/exams/syllabus-templates${qs(filters)}`);
  return res.data;
};
